"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

require("core-js/modules/es6.function.bind.js");

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Hovertip = _interopRequireDefault(require("../Hovertip"));

var _style = require("./style");

var _excluded = ["icon", "prefix", "iconProps", "placement"];

var _this = void 0;

/**
 * Hovertip.Icontip
 * @description 图标悬停提示
 */
var Icontip = function Icontip(_ref) {
  var _this2 = this;

  (0, _newArrowCheck2["default"])(this, _this);
  var icon = _ref.icon,
      prefix = _ref.prefix,
      iconProps = _ref.iconProps,
      placement = _ref.placement,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var alignConf = {
    topLeft: {
      points: ["bl", "tl"],
      overflow: {
        adjustX: 1,
        adjustY: 1
      },
      offset: [-10, -10],
      targetOffset: [0, 0]
    },
    bottomLeft: {
      points: ["tl", "bl"],
      overflow: {
        adjustX: 1,
        adjustY: 1
      },
      offset: [-10, 10],
      targetOffset: [0, 0]
    },
    topRight: {
      points: ["br", "tr"],
      overflow: {
        adjustX: 1,
        adjustY: 1
      },
      offset: [10, -10],
      targetOffset: [0, 0]
    },
    bottomRight: {
      points: ["tr", "br"],
      overflow: {
        adjustX: 1,
        adjustY: 1
      },
      offset: [10, 10],
      targetOffset: [0, 0]
    }
  };

  var renderIcon = function renderIcon() {
    (0, _newArrowCheck2["default"])(this, _this2);

    if ((0, _isString2["default"])(icon)) {
      return /*#__PURE__*/_react["default"].createElement(_style.StyledIcon, (0, _extends2["default"])({
        type: icon,
        prefix: prefix
      }, iconProps));
    }

    return /*#__PURE__*/_react["default"].createElement(_style.StyledSpan, {
      className: _style.iconCls
    }, icon);
  }.bind(this);

  return /*#__PURE__*/_react["default"].createElement(_Hovertip["default"], (0, _extends2["default"])({
    placement: placement,
    align: alignConf[placement] || {}
  }, others), renderIcon());
}.bind(void 0);

Icontip.propTypes = {
  /**
   * 图标的props
   */
  iconProps: _propTypes["default"].object,

  /**
   * 图标，传入string时为图标类型，也可直接传入图标组件
   */
  icon: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** 
   * icon类名前缀，当icon为图标组件时，会被忽略
   */
  prefix: _propTypes["default"].string,

  /**
   * 弹出层位置，同基础组件Popover的placement
   */
  placement: _propTypes["default"].string
};
Icontip.defaultProps = {
  iconProps: {},
  icon: "circle-question",
  prefix: "icon-uc-suggested__",
  placement: "topLeft"
};
var _default = Icontip;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/Hovertip/Icontip.js
// module id = 2095
// module chunks = 6 7 17 18